import { render } from 'preact';
import { html } from 'htm/preact';
import ServicelocationFetcher from './servicelocation-fetcher';

export default function init() {
  const root = document.getElementById('servicelocation-search');

  if (root) {
    render(html`<${ServicelocationFetcher} />`, root);
  }
}
